// @flow
import { Record, Map as ImmutableMap } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';

type SpendingWatchListStoreProps = QcsSyncResourceStoreProps & {

}

export type SpendingWatchListStore = RecordOf<SpendingWatchListStoreProps>;

export const mkSpendingWatchListStore: RecordFactory<SpendingWatchListStoreProps> =
  Record({
    resourcesById: ImmutableMap(),

    lastSyncDate: null,
    loadPending: true,

    isLoading: false,
  });

type SpendingWatchListProps = {
  id: string,
  clientId: ?string,
  isDeleted: ?boolean,
  name: ?string,
  filterId: ?string,
  thisMonth: ?number,
  yearToDate: ?number,
  monthlyTrend: ?number,
  numMonthlyTrendMonths: ?number,
  monthSpendingProjection: ?number,
  targetAmount: ?number,
  resetTargetAmount: ?boolean,
  emoji: ?string,
  createdAt: ?string,
}
export type SpendingWatchList = RecordOf<SpendingWatchListProps>;

export const mkSpendingWatchList: RecordFactory<SpendingWatchListProps> =
  Record({
    id: '',
    clientId: null,
    isDeleted: null,
    name: 'unknown',
    filterId: '',
    thisMonth: null,
    yearToDate: null,
    monthlyTrend: null,
    numMonthlyTrendMonths: null,
    monthSpendingProjection: null,
    targetAmount: null,
    resetTargetAmount: null,
    emoji: '',
    createdAt: '',
  });
